import type { RequestDocument } from 'graphql-request';

const DISTRIBUTION_CHANNEL_FIELDS = `
  id
  title
  internalTitle
  slug
  description
  channelType
  icon { url }
`;

const ATTACHMENT_BLOCK_INLINE_FRAGMENTS = `
  ... on AttachmentImageBlockRecord {
    _modelApiKey
    id
    role
    maxCount
    maxSizeMb
    minDimensions
    maxDimensions
    aspectRatios
    mimeTypes
    altTextMaxChars
    additionalConstraintsJson
  }
  ... on AttachmentVideoBlockRecord {
    _modelApiKey
    id
    role
    maxCount
    minSeconds
    maxSeconds
    maxSizeMb
    minDimensions
    maxDimensions
    aspectRatios
    frameRateMin
    frameRateMax
    codecs
    mimeTypes
    coverImageSupported
    captionsSupported
    additionalConstraintsJson
  }
  ... on AttachmentDocumentBlockRecord {
    _modelApiKey
    id
    maxCount
    maxPages
    maxSizeMb
    mimeTypes
    additionalConstraintsJson
  }
  ... on AttachmentLinkShareBlockRecord {
    _modelApiKey
    id
    maxCount
    additionalConstraintsJson
  }
  ... on AttachmentPollBlockRecord {
    _modelApiKey
    id
    maxCount
    questionMaxChars
    optionsMin
    optionsMax
    optionMaxChars
    durationOptionsDays
    additionalConstraintsJson
  }
`;

const DISTRIBUTION_CHANNEL_FORMAT_FIELDS = `
  id
  title
  internalTitle
  formatType
  titleMaxChars
  textMaxChars
  totalAttachmentsMax
  allowMixingAttachmentTypes
  additionalConstraintsJson
  attachments {
    ${ATTACHMENT_BLOCK_INLINE_FRAGMENTS}
  }
`;

export const ENABLED_DISTRIBUTION_CHANNELS_QUERY: RequestDocument = `
  query getEnabledDistributionChannels($id: ItemId!) {
    showcase(filter: { id: { eq: $id } }) {
      enabledDistributionChannels {
        ${DISTRIBUTION_CHANNEL_FIELDS}
      }
    }
  }
`;

export const ALL_DISTRIBUTION_CHANNELS_QUERY: RequestDocument = `
  query getAllDistributionChannels {
    allDistributionChannels(first: 100) {
      ${DISTRIBUTION_CHANNEL_FIELDS}
      availableToShowcases { id }
    }
  }
`;

export const DISTRIBUTION_CHANNEL_FORMATS_QUERY: RequestDocument = `
  query getDistributionChannelFormats($channelIds: [ItemId!]!) {
    allDistributionChannelFormats(filter: { channel: { in: $channelIds } }, first: 100) {
      channel { id }
      ${DISTRIBUTION_CHANNEL_FORMAT_FIELDS}
    }
  }
`;
